import React from "react";
import PropTypes from "prop-types";
import styles from "./apiTool.module.css";

/** Absent, empty-string and object values all need to read differently from a plain value. */
export function FieldValue({value}) {
    if (value === undefined) return <span className={styles.muted}>–</span>;
    if (value === null) return <span className={styles.muted}>null</span>;
    if (value === "") return <span className={styles.muted}>&quot;&quot;</span>;
    if (typeof value === "object") return <>{JSON.stringify(value)}</>;
    return <>{String(value)}</>;
}

FieldValue.propTypes = {
    // whatever the API returned - absent, null, empty, a scalar or an object
    value: PropTypes.any,
};

/**
 * The field/value table two views share: the properties of a response with no comparison, and the
 * unmapped fields of each side of one. Only the value column's heading differs between them.
 */
export default function FieldTable({valueHeader, rows}) {
    return (
        <table>
            <thead>
                <tr><th>Field</th><th>{valueHeader}</th></tr>
            </thead>
            <tbody>
                {rows.map(row => (
                    <tr key={row.field}>
                        <td><code>{row.field}</code></td>
                        <td className={styles.val}><FieldValue value={row.value}/></td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

FieldTable.propTypes = {
    valueHeader: PropTypes.string.isRequired,
    // `field` identifies the row, so it has to be unique within one table
    rows: PropTypes.arrayOf(PropTypes.shape({
        field: PropTypes.string.isRequired,
        value: PropTypes.any,
    })).isRequired,
};
